

































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeContratosStore from '../contratos/Store/BackofficeContratosStore'
import EventBus from '@/plugins/EventBus'
import _ from 'lodash'

const MIN_SEARCH_LENGTH = 3

type DebouncedSearch = (() => void) & { cancel: () => void }

@Component
export default class RemuneracaoSuporteContratosRightNavBar extends Vue {
  filterLoading: boolean = false
  searchPrestador: string = ''
  loadingPrestadorFilter: boolean = false
  ignoreNextPrestadorSearch: boolean = false
  searchGestor: string = ''
  loadingGestorFilter: boolean = false
  ignoreNextGestorSearch: boolean = false

  prestadoresDebounced!: DebouncedSearch
  gestoresDebounced!: DebouncedSearch

  created() {
    this.prestadoresDebounced = _.debounce(async () => {
      const termo = (this.searchPrestador || '').trim()

      if (termo.length < MIN_SEARCH_LENGTH) {
        this.loadingPrestadorFilter = false
        return
      }

      try {
        await this.getBackofficeContratosStore.getPrestadoresBySearch({ search: termo })
      } finally {
        this.loadingPrestadorFilter = false
      }
    }, 700)

    this.gestoresDebounced = _.debounce(async () => {
      const termo = (this.searchGestor || '').trim()

      if (termo.length < MIN_SEARCH_LENGTH) {
        this.loadingGestorFilter = false
        return
      }

      try {
        await this.getBackofficeContratosStore.getGestoresBySearch({ nome: termo })
      } finally {
        this.loadingGestorFilter = false
      }
    }, 700)
  }

  get getBackofficeContratosStore() {
    return getModule(BackofficeContratosStore, this.$store)
  }

  get drawer() {
    return this.getBackofficeContratosStore.filterDrawer
  }

  set drawer(value: boolean) {
    this.getBackofficeContratosStore.setFilterDrawer(value)
  }

  get grupoHospitalOptions() {
    return this.getBackofficeContratosStore.grupoHospitalOptions
  }

  get grupoHospital() {
    return this.getBackofficeContratosStore.filtroGrupoHospital
  }

  set grupoHospital(value: string) {
    this.getBackofficeContratosStore.setFiltroGrupoHospital(value)
  }

  get cpfGestor() {
    return this.getBackofficeContratosStore.filtroCpfGestor
  }

  set cpfGestor(value: string) {
    this.getBackofficeContratosStore.setFiltroCpfGestor(value)
  }

  get gestor() {
    return this.getBackofficeContratosStore.filtroGestor
  }

  set gestor(value: string) {
    this.getBackofficeContratosStore.setFiltroGestor(value)
  }

  get cnpjPrestador() {
    return this.getBackofficeContratosStore.filtroCnpjPrestador
  }

  set cnpjPrestador(value: string) {
    this.getBackofficeContratosStore.setFiltroCnpjPrestador(value)
  }

  get prestador() {
    return this.getBackofficeContratosStore.filtroPrestador
  }

  set prestador(value: string) {
    this.getBackofficeContratosStore.setFiltroPrestador(value)
  }

  get prestadoresList() {
    return this.getBackofficeContratosStore.prestadores
  }

  get prestadorNoDataText(): string {
    if (
      this.searchPrestador &&
      this.searchPrestador.length >= MIN_SEARCH_LENGTH
    ) {
      return 'Nenhum prestador encontrado'
    }

    return 'Digite ao menos 3 letras para buscar'
  }

  @Watch('searchPrestador')
  onSearchPrestadorChanged(val: string) {
    if (this.ignoreNextPrestadorSearch) {
      this.ignoreNextPrestadorSearch = false
      return
    }

    this.loadingPrestadorFilter = (val || '').trim().length >= MIN_SEARCH_LENGTH

    this.prestadoresDebounced()
  }

  onChangePrestador() {
    this.ignoreNextPrestadorSearch = true
    this.prestadoresDebounced.cancel()
    this.loadingPrestadorFilter = false
  }

  get gestores() {
    return this.getBackofficeContratosStore.gestores
  }

  get gestorNoDataText(): string {
    if (this.searchGestor && this.searchGestor.length >= MIN_SEARCH_LENGTH) {
      return 'Nenhum gestor encontrado'
    }

    return 'Digite ao menos 3 letras para buscar'
  }

  @Watch('searchGestor')
  onSearchGestorChanged(val: string) {
    if (this.ignoreNextGestorSearch) {
      this.ignoreNextGestorSearch = false
      return
    }

    this.loadingGestorFilter = (val || '').trim().length >= MIN_SEARCH_LENGTH

    this.gestoresDebounced()
  }

  onChangeGestor() {
    this.ignoreNextGestorSearch = true
    this.gestoresDebounced.cancel()
    this.loadingGestorFilter = false
  }

  set tableLoading(value: boolean) {
    this.getBackofficeContratosStore.setLoadingTabelaContratos(value)
  }

  async search() {
    this.filterLoading = true
    this.tableLoading = true

    try {
      await this.getBackofficeContratosStore.getContratosVisaoGestor()
      await this.getBackofficeContratosStore.getContratosVisaoGestorBaseRemuneracao()
    } catch (error) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Erro ao buscar contratos',
        icon: 'warning',
        color: '#C62828',
      })
    } finally {
      this.filterLoading = false
      this.tableLoading = false
    }
  }

  async clear() {
    this.prestadoresDebounced.cancel()
    this.gestoresDebounced.cancel()
    this.loadingPrestadorFilter = false
    this.loadingGestorFilter = false

    this.searchPrestador = ''
    this.searchGestor = ''
    this.getBackofficeContratosStore.setFiltroGrupoHospital('')
    this.getBackofficeContratosStore.setFiltroCpfGestor('')
    this.getBackofficeContratosStore.setFiltroGestor('')
    this.getBackofficeContratosStore.setFiltroCnpjPrestador('')
    this.getBackofficeContratosStore.setFiltroPrestador('')

    await this.search()
  }
}
